import CertificationEdit from "../Edits/CertificationEdit";
import CmModal from "../Controls/CmModal";

export default function CertificationEditModal({ certificationId = 0, onClose }) {
  const id = Number.parseInt(certificationId, 10) || 0;
  const title = id > 0 ? "Certification" : "Add Certification";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="form"
      testId="certification-edit-modal"
    >
      <CertificationEdit certificationId={id} onClose={onClose} />
    </CmModal>
  );
}
